import faker from 'faker'

export const mocker = {
  warningmsg () {
    let mockRows = []
    const mockTotal = 10
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        message: faker.lorem.words()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/warningmsg/mocker.js